export default __webpack_public_path__ + "static/media/logo_mga.2a626e68.png";